import React from 'react';
import PropTypes from 'prop-types';
import { Divider, } from "~/native-ui/Divider"
import { Box, VStack } from "~/native-ui/native-base"

const Card = ({ children, className, raised, space, hasDivider, ...other }) => {
    return (
        <Box shadow={raised ? 2 : undefined} borderRadius='md' {...other}>
            <VStack space={ space ?? 2 } divider={ hasDivider ? <Divider /> : null }>
                {children}
            </VStack>
        </Box>
    );
};

Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    raised: PropTypes.bool,
    hasDivider: PropTypes.bool,
    theme: PropTypes.shape({
        card: PropTypes.string,
        raised: PropTypes.string,
    }),
};

Card.defaultProps = {
    hasDivider: true,
}

export default Card;
export { Card };
